/* ==========================================================================
   RW Forms — review cards + submission collection (loaded after rwf-core.js).
   Extends RWF.Form: display() formats an answer, collect() gathers visible,
   non-empty answers per step (hidden branches stripped), buildReview()
   renders the Edit-able summary into [data-rwf-review].
   ========================================================================== */
(function () {
  'use strict';
  var RWF = window.RWF;
  var Form = RWF.Form;
  var truthy = RWF.truthy;

  Form.prototype.display = function (f) {
    var val = this.v[f.name];
    if (this.cfg.display && this.cfg.display[f.name]) return this.cfg.display[f.name](val, this.v, this);
    if (!truthy(val)) return '';
    if (f.kind === 'choice') {
      var arr = Array.isArray(val) ? val : [val];
      return arr.map(function (x) {
        var b = f.el.querySelector('[data-value="' + String(x).replace(/"/g, '\\"') + '"]');
        if (!b) return x;
        return b.getAttribute('data-label') || (b.querySelector('strong') || b).textContent.replace(/\s+/g, ' ').trim();
      }).join(', ');
    }
    if (f.kind === 'ms') return RWF.multiLabels(f.el, val).join(', ');
    if (f.kind === 'checkbox') return f.el.getAttribute('data-yes') || 'Yes';
    if (f.kind === 'select') {
      var o = f.el.querySelector('option[value="' + String(val).replace(/"/g, '\\"') + '"]') ||
        Array.prototype.filter.call(f.el.options, function (op) { return op.value === val; })[0];
      return o ? o.textContent.trim() : val;
    }
    if (f.kind === 'radio') {
      var r = f.els.filter(function (x) { return x.value === val; })[0];
      var lab = r && r.closest('label');
      return lab ? lab.textContent.replace(/\s+/g, ' ').trim() : val;
    }
    return String(val);
  };

  Form.prototype.collect = function () {
    var self = this;
    var data = {};
    var sections = this.included().map(function (step) {
      var rows = [];
      self.order.forEach(function (f) {
        if (f.step !== step || !self.active(f) || !truthy(self.v[f.name])) return;
        data[f.name] = self.v[f.name];
        var d = self.display(f);
        if (f.el.getAttribute('data-validate') === 'phone' && RWF.phoneLooksFake(self.v[f.name])) {
          d += ' (please verify — looks like a placeholder number)';
        }
        if (d !== '') rows.push({ name: f.name, label: self.labelOf(f), value: d, skip: f.el.hasAttribute('data-review-skip') });
      });
      return { id: step.getAttribute('data-step'), title: step.getAttribute('data-title'), rows: rows, review: !step.querySelector('[data-rwf-review]') };
    });
    var extra = this.cfg.extra ? this.cfg.extra(this.v, this) || [] : [];
    return { sections: sections, data: data, extra: extra };
  };

  Form.prototype.buildReview = function () {
    var box = this.$('[data-rwf-review]');
    if (!box) return;
    box.classList.add('rwf-review');
    box.innerHTML = this.collect().sections.filter(function (s) { return s.review && s.rows.length; }).map(function (s) {
      return '<div class="rwf-rcard"><div class="rwf-rcard__head"><h3>' + RWF.esc(s.title) + '</h3>' +
        '<button type="button" class="rwf-lnk" data-rwf-goto="' + RWF.esc(s.id) + '">Edit</button></div><dl style="margin:0">' +
        s.rows.filter(function (r) { return !r.skip; }).map(function (r) { return '<div class="rwf-rrow"><dt>' + RWF.esc(r.label) + '</dt><dd>' + RWF.esc(r.value) + '</dd></div>'; }).join('') +
        '</dl></div>';
    }).join('');
  };
})();
